<template>
  <div class="uupay-container">

    <section class="modules-section">
      <div class="container modules-section-container">
        <div class="content my-4">
          <div class="row">
            <div class="col-md-12">
              <router-link to="/blog">
                <div class="back d-flex align-items-center">
                  <div class="mr-2"><img src="@/assets/uupay/icon/svg/wonder_blog_arrow_left.svg" class="img-fluid"></div>
                  <div>返回商戶成功案例</div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="container modules-section-container">

        <div class="content my-5 pb-3">
          <div class="row gx-3">
            <div class="col-md-6">
              <div class="h-100 pr-3 d-flex flex-column justify-content-center">
                <div class="title">
                  高級餐廳閩粵軒如何利用微網紅行銷賺取達9.6倍回報
                </div>
                <div class="subtitle">
                  商戶選用UUPay智能POS收款機迎合顧客支付習慣的改變，同時率先使用流量推廣服務，為閩粵軒迅速於社交媒體爭取曝光及吸納客人。
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div>
                <img src="@/assets/uupay/images/merchant_detail_banner.png" alt="" class="img-fluid">
              </div>
            </div>
          </div>
        </div>

        <div class="content mt-5 mb-3 py-3">

          <div class="d-flex my-4">
            <div class="w-50"><el-divider></el-divider></div>
            <div class="img-side-divider"><el-divider></el-divider></div>
          </div>
          
          
          <div class="row gx-3">
            <div class="col-md-6">
              <div class="text-side h-100 pr-3 d-flex flex-column justify-content-center align-items-center">
                <div class="rate">+60%</div>
                <div class="rate-desc mt-3">結算效率</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="img-side d-flex flex-column align-items-center">
                <div class="rate">+50%</div>
                <div class="rate-desc mt-3">帳單支付效率</div>
              </div>
            </div>
          </div>
          
          <div class="d-flex mt-4">
            <div class="w-50"><el-divider></el-divider></div>
            <div class="img-side-divider"><el-divider></el-divider></div>
          </div>
          
        </div>

        <div class="content custom-width mb-5">
          <div class="row gx-5">
            <div class="col d-flex justify-content-center" v-for="item in solutions">
              <div class="card">
                <div>
                  <div></div>
                  <div>{{ item.title }}</div>
                </div>
                <ul>
                  <li v-for="info in item.list">
                    {{ info.desc }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>

    </section>
    
  </div>
</template>
<script>

export default {
  name: 'MerchantDetail',
  components: {
  },
  data() {
    return {
      solutions: [
        { id: 0, title: '痛點', list: [
          { icon: '', desc: '開戶時間長' },
          { icon: '', desc: '結算條件複雜、週期長' },
          { icon: '', desc: '資金壓力影響原料採購' },
          { icon: '', desc: '人工帳本出錯率高' },
        ]},
        { id: 0, title: '解決', list: [
          { icon: '', desc: 'UUPay 快捷開戶' },
          { icon: '', desc: '結算時間短，效率高' },
          { icon: '', desc: '智能財務報表提供' },
        ]},
        { id: 0, title: '影響', list: [
          { icon: '', desc: '結算效率提高' },
          { icon: '', desc: '支付效率提高' },
          { icon: '', desc: '人手成本減少' },
        ]},
      ]
    }
  },
  mounted() {

  },
  methods: {
    getIcon(name) {
      return require(`@/assets/uupay/icon/svg/${name}.svg`)
    },
  },
  
}
</script>
<style scoped>


.modules-section {
  color: #21042e;
  background-color: #fff;
  font-weight: 400;
}

.modules-section .back {
  font-size: 20px;
  line-height: 100%;
  font-weight: 500;
  margin: 1.2rem 0;
  color: #21042e;
  cursor: pointer;
}
.modules-section .title {
  font-size: 40px;
  line-height: 54px;
  margin: 1.2rem 0;
}
.modules-section .subtitle {
  color: #bc68a4;
  font-size: 16px;
  line-height: 30px;
}

.rate {
  font-size: 60px;
  line-height: 80px;
  background: linear-gradient(to bottom, #b94395 0%, #840c60 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.rate-desc {
  color: #76667c;
  font-size: 16px;
  line-height: 30px;
}


.img-side {
  width: 440px;
}
.img-side-divider {
  width: 465px;
}

.custom-width {
  width: calc(50% + 415px);
}

.card {
  background-color: #f8f8f8;
  border: 1px solid #f5f5f5;
  border-radius: 10px;
  width: 280px;
  height: 310px;
}
.card li::marker {
  color: #9a307a;          /* 修改标记颜色 */
  font-size: 20px;     /* 修改标记大小 */
  line-height: 20px;
}

@media (min-width: 1700px) {
  .modules-section-container {
    max-width: 1440px;
  }
}

@media (min-width: 1280px) {
  .modules-section .content {
    margin: 0 3rem;
  }
}


</style>


// WEBPACK FOOTER //
// src/views/MerchantDetail.vue